import type { MediaKitSocialFieldKey, MediaKitSocialFormState } from '../utils/mediaKitFormUtils';
import { MEDIA_KIT_SOCIAL_FIELDS } from '../utils/mediaKitFormUtils';
import { MEDIA_KIT_SOCIAL_PLATFORM_META } from './mediaKitSocialPlatforms';

interface MediaKitSocialFieldsProps {
    values: MediaKitSocialFormState;
    errors?: Record<string, string>;
    onChange: (key: MediaKitSocialFieldKey, value: string) => void;
}

export default function MediaKitSocialFields({ values, errors = {}, onChange }: MediaKitSocialFieldsProps) {
    return (
        <div className="media-kit-social-grid">
            {MEDIA_KIT_SOCIAL_FIELDS.map(({ key }) => {
                const { label, placeholder, iconClass, Icon } = MEDIA_KIT_SOCIAL_PLATFORM_META[key];
                return (
                    <div key={key} className="media-kit-social-item">
                        <div className="media-kit-social-item-label">
                            <span className={`media-kit-social-icon ${iconClass}`} aria-hidden="true">
                                <Icon className="media-kit-social-icon-svg" />
                            </span>
                            <strong>{label}</strong>
                        </div>
                        <input
                            type="text"
                            className="media-kit-input"
                            value={values[key]}
                            onChange={(e) => onChange(key, e.target.value)}
                            placeholder={placeholder}
                            autoComplete="off"
                            data-testid={`media-kit-social-${key}`}
                        />
                        {errors[key] && <span className="media-kit-error">{errors[key]}</span>}
                    </div>
                );
            })}
        </div>
    );
}
